import { render, staticRenderFns } from "./GameHistoryPrivate.vue?vue&type=template&id=43f0aa26&scoped=true"
import script from "./GameHistoryPrivate.vue?vue&type=script&lang=js"
export * from "./GameHistoryPrivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0aa26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43f0aa26')) {
      api.createRecord('43f0aa26', component.options)
    } else {
      api.reload('43f0aa26', component.options)
    }
    module.hot.accept("./GameHistoryPrivate.vue?vue&type=template&id=43f0aa26&scoped=true", function () {
      api.rerender('43f0aa26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/battleground/components/GameHistoryPrivate.vue"
export default component.exports